import React from 'react';

import './index.scss';

export default (props) => {

    return (
        <div className="backgroundImage">
            <div className="cranmoreWrap">
                <div className="mainIcon">
                    <a href="http://www.cranmore.com/"><img alt="purgatory logo" src={props.config.assets.footer.logo} /></a>
                    <div className="bottomInformation">
                        <div className="resortInformation">
                            <span>Resort Information</span>
                            <span>1-800-SUN-N-SKI</span>
                        </div>
                        <div className="resortLodging">
                            <span>Resort Lodging</span>
                            <span>1-866-422-0585</span>
                        </div>
                        <div className="address">
                            <span>239 Skimobile Road • PO Box 1640 • North Conway, NH 03860</span>
                        </div>
                    </div>
                </div>
                <div className="highlights">
                    <h2>Resort Highlights - Destination North Conway</h2>
                    <p> From skiing and snowboarding to shopping at its famous discount retail outlets, 
                        recreation and fun centered around Cranmore Mountain Resort abound in scenic North Conway. 
                        The resort itself holds a long tradition of ski culture that dates back to the great Ski Meister Hannes Schneider in 1939
                    </p>
                </div>
            </div>
        </div>
    );
}